import {Component, Input} from '@angular/core';

@Component({
  selector: 'iconify',
  templateUrl: './iconify.component.html',
  styleUrls: ['./iconify.component.css']
})
export class IconifyComponent {

  @Input() name = '';
  @Input() classNames = '';
  @Input() size:number | string = 0;

  get style(){
    return `
      ${this.size ? `font-size: ${this.size}px;` : ''}
    `
  }
}
